import { onlyCallFnOnceWhilePreviousCallIsPending } from "libs/promise-utils";
import { focusReply } from "../utils";
import { ClientEnvironment } from "~/environment/ClientEnvironment";
import { openComposeNewThreadDialog } from "~/page-dialogs/page-dialog-state";
import { unscheduleMessageToBeSent } from "~/actions/message";

export const unsendAndFocusDraft = onlyCallFnOnceWhilePreviousCallIsPending(
  async (props: { environment: ClientEnvironment; draftId: string; isReply: boolean }) => {
    const { environment, draftId, isReply } = props;

    using disposable = environment.isLoading.add();

    const draftLocation = environment.router.location();

    // TODO: @Sudeep - There is currently a bug here (pre-dating Actions) where unsending a message while looking at
    // /threads/:id causes the updated draft to be seen as a reply draft which through the rendering chain/hooks
    // updates the subject to null.
    // When the user is brough back to the compose screen, their new thread draft has no subject.

    await unscheduleMessageToBeSent(environment, { messageId: props.draftId });

    if (isReply) {
      focusReply(environment, draftId, draftLocation);
    } else {
      openComposeNewThreadDialog(environment, draftId);
    }
  },
);
